import { render, staticRenderFns } from "./FullPageLoader.vue?vue&type=template&id=5e152b40&scoped=true&"
var script = {}
import style0 from "./FullPageLoader.vue?vue&type=style&index=0&id=5e152b40&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e152b40",
  null
  
)

export default component.exports